import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { OnlineUseActions } from './online-use.actions';

@Injectable({
  providedIn: 'root'
})
export class OnlineUseEffects {
  sendOnlineUseEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendOnlineUseEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(OnlineUseActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
